<template>
    <div class="modal">
        <div class="modal-container">
            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>Request Replies</h1>
            </div>

            <div class="modal-body no-pad">
                <div class="flex h-full">
                    <div class="w-full">
                        <div class="reply-body" v-if="replies">
                            <p>The total number of results is <strong>{{ replies.length }}</strong></p>
                            <div class="results-list">
                                <div class="results-row">
                                    <div class="results-head uppercase" data-width="20%">Id</div>
                                    <div class="results-head" data-width="50%">From</div>
                                    <div class="results-head" data-width="30%">Date/Time</div>
                                </div>
                                <div class="results-row" v-for="(reply, index) in replies" :key="index"
                                     @click="viewReply(reply)">
                                    <div class="results-cell" data-width="20%">{{ reply.reply_id }}</div>
                                    <div class="results-cell reply-cell" data-width="50%">
                                        <span class="guest replied-type" v-if="reply.reply_id == -1">Guest</span>
                                        <span class="account replied-type" v-else>Account</span>
                                        {{ reply.reply_email }}
                                    </div>
                                    <div class="results-cell" data-width="30%">{{
                                            formatDateShort(reply.reply_datetime)
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="left text-left">
                        <button class="btn-primary muted" type="button" @click="loadData('successful')">Successful
                        </button>
                        <button class="btn-primary muted" type="button" @click="loadData('filtered')">Filtered</button>
                        <button class="btn-primary muted" type="button" @click="loadData('bounced')">Bounced</button>
                    </div>
                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    </div>
                </div>
            </div>
        </div>

        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>
<script>
import ReplyView from './ReplyView'

export default {
    name: 'MediaRequestRepliesList',
    components: {
        ReplyView
    },
    data() {
        return {
            replies: null,
        }
    },
    mounted() {
        this.setMetaTitle('List Media Requests Replies | JournoLink Control')
        this.loadData()
    },
    methods: {
        loadData(type = 'successful') {
            axios.get(route('mediarequests.replies', {mediaRequest: this.$route.params.mediaRequestId, type: type}))
                .then((response) => {
                    this.replies = response.data
                })
        },
        closeView() {
            this.$router.go(-1)
        },
        viewReply(reply) {
            this.$router.push({
                name: 'mediarequests.replies.show',
                params: {
                    mediaRequestId: this.$route.params.mediaRequestId,
                    reply: reply.reply_id,
                }
            })
        }
    },
}
</script>

<style lang="less">
.reply-body {
    padding: 15px;

    .reply-cell {
        .replied-type {
            padding: 5px;
            border-radius: 3px;
            color: white;
        }

        .account {
            background-color: #2980b9;

        }

        .guest {
            background-color: #2c3e50;
        }
    }
}
</style>
